module.exports = __webpack_public_path__ + "fa-solid-900.85224f3327dd8ce40419.svg";


//////////////////
// WEBPACK FOOTER
// E:/xampp/htdocs/liberado/CocoraSMFront/src/assets/plugins/fontawesome-free/webfonts/fa-solid-900.svg
// module id = ../../../../../src/assets/plugins/fontawesome-free/webfonts/fa-solid-900.svg
// module chunks = styles